import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';
import { homePathForAuthUser } from '../auth/routing.js';

/** Authenticated entry: routes signed-in users to the correct product surface. */
export function AppEntryRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="page-loading">
        <div className="spinner" aria-hidden />
        <p>Loading your session…</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return <Navigate to={homePathForAuthUser(user)} replace />;
}
